import { OrderFulfillmentTypeEnum } from "@/enum";

export const orderFulfillmentTypeLabels: Record<OrderFulfillmentTypeEnum, string> = {
  [OrderFulfillmentTypeEnum.DineIn]: "Dine In",
  [OrderFulfillmentTypeEnum.TakeAway]: "Take Away",
  [OrderFulfillmentTypeEnum.Delivery]: "Delivery",
};
